import { render, staticRenderFns } from "./bwemails.vue?vue&type=template&id=178e259e&"
import script from "./bwemails.vue?vue&type=script&lang=js&"
export * from "./bwemails.vue?vue&type=script&lang=js&"
import style0 from "./bwemails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports